<ng-template #template>
    <!-- <h5 class="modal-title pull-left">Scan QR on your authenticator app</h5> -->
    <div class="modal-body d-flex justify-content-center align-items-center flex-column p-4">
        <h5 class="text-center mb-3">Two-Factor Authentication (2FA)</h5>
    
        <p class="text-center">Enable or disable 2FA for added security.</p>
        @if (isLoading) {
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
    
            </div>
        }@else {
            <mat-slide-toggle [(ngModel)]="enable2Fa" (ngModelChange)="toggle2FA()" [disabled]="enable2Fa">
                {{ enable2Fa ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>

            @if(enable2Fa){
               <p class="text-center mt-2"> <span class="text-muted">Please contact admin regarding deactivation.</span></p>
            }
        }
     
    </div>
    
    <mat-divider class="horizontal-divider"></mat-divider>
    <div class="modal-footer">

        <button mat-stroked-button color="primary" class="btn-border outline-info-btn btn-text-size" (click)="close()">
            Cancel <mat-icon>cancel</mat-icon> 
        </button>
      
    </div>
</ng-template>
